module.exports = __webpack_public_path__ + "img/customer_bjgz.6ec3fb4c.svg";